import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="similarity-slider"
export default class extends Controller {
  static targets = ["slider", "hiddenField"]

  connect() {
    // Initialize with inverted value
    const actualValue = parseFloat(this.hiddenFieldTarget.value)
    this.sliderTarget.value = this.invertValue(actualValue)
  }

  invertValue(value) {
    // Invert the range: 0 becomes 2, 2 becomes 0
    return 2 - parseFloat(value)
  }

  updateSimilarity(sliderValue) {
    // Convert slider value (0-2) to actual value (2-0)
    const actualValue = this.invertValue(sliderValue)
    const clampedValue = Math.max(0, Math.min(2, actualValue))
    this.hiddenFieldTarget.value = clampedValue
  }

  sliderChanged(event) {
    this.updateSimilarity(event.target.value)
  }
}
